// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2Cs5i","title":"Images45_title__21uNb","images":"Images45_images__1XIfW"};